/* One integration's at-a-glance state. Shared by the clients list and the client
   page header, so the same chip means the same thing in both places. */
export function ConnChip({ label, on, detail }: { label: string; on: boolean; detail?: string | null }) {
  return (
    <span
      className={`admin-conn ${on ? 'admin-conn--on' : 'admin-conn--off'}`}
      title={on ? `${label}: ${detail ?? 'enabled'}` : `${label}: not configured`}
    >
      {label}
    </span>
  );
}
